import type * as React from 'react';

export interface ChatDrawerIconProps extends React.ComponentProps<'svg'> {
  size?: number;
}

function glyph(size: number, props: Omit<ChatDrawerIconProps, 'size'>) {
  return {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
    ...props,
  } as const;
}

/**
 * Out of the strip, into the column: a chevron pointing away from the edge the
 * panel is parked against, with that edge drawn. The prototypes' own pair —
 * lucide's panel icons say "a panel exists", not which way this one goes.
 */
export function ChatExpandIcon({ size = 14, ...props }: ChatDrawerIconProps) {
  return (
    <svg {...glyph(size, props)}>
      <path d='M11 6 5 12l6 6' />
      <path d='M19 4v16' />
    </svg>
  );
}

/** The same movement the other way: back to the edge, leaving the strip. */
export function ChatCollapseIcon({ size = 17, ...props }: ChatDrawerIconProps) {
  return (
    <svg {...glyph(size, props)}>
      <path d='M5 6l6 6-6 6' />
      <path d='M19 4v16' />
    </svg>
  );
}
